function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGamePlaystation = function SvgGamePlaystation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.7 17.4c-1.1.8-.8 2.2 1.6 2.9 2.5.8 5.2 1 7.8.6l.3-.1v-2.5L8 19c-1 .3-2 .4-2.9.1-.7-.2-.6-.6.3-1l5.1-1.8v-2.8l-7.1 2.5c-.9.3-1.8.8-2.6 1.3ZM18 6.3v7.2c3 1.5 5.4 0 5.4-3.9 0-4-1.4-5.7-5.5-7.1-2.2-.8-4.4-1.4-6.6-1.9v21.5l5.2 1.6V5.6c0-.8 0-1.4.6-1.2.8.2.9 1 .9 1.9Zm9.7 9.4a15.9 15.9 0 0 0-10.1 0h-.2v3l4.8-1.8c1-.3 2-.4 3-.2.7.2.5.7-.4 1l-7.4 2.8v2.8l10.3-3.8c.7-.3 1.4-.6 2-1.2.5-.8.3-1.8-2-2.6Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgGamePlaystation;